import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { PrivilegeResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post } from "./common";

export const privilege = {
    record(data: typeof Requests.Privilege.Record.Input) {
        return post<typeof data, PrivilegeResponseTypes.Record>(`/privilege/record`, data);
    },
    create(data: typeof Requests.Privilege.Create.Input) {
        return post<typeof data>(`/privilege/create`, data);
    },
    obtain(id: string) {
        return get<PrivilegeResponseTypes.Obtain>(`/privilege/obtain/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<PrivilegeResponseTypes.Select>(
                `/privilege/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        async obtainTemplate(id: string) {
            const result = await get<PrivilegeResponseTypes.ObtainTemplate>(
                `/privilege/obtain-template/${id}`,
            ).execute();

            if (result === undefined) return [];
            return result;
        },
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Privilege.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/privilege/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
